module.exports = __webpack_public_path__ + "static/media/camper.71bb77ae.png";